import { TagRulePanel } from '@/features/settings/TagRulePanel'

/**
 * 标签规则：条件命中就给主体赋标签。
 *
 * Its own page rather than a block on 语义库, because it is a rule editor: the
 * conditions come from the same builder as 域名规则, and sitting under 规则管理
 * beside them says what it is more clearly than sitting above a data table.
 */
export default function TagRulesPage() {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-lg font-medium">标签规则</h1>
        <p className="mt-1 text-xs text-muted-foreground">
          条件命中就给域名主体赋上标签。标签显示在语义库和域名库的「特征」列，
          也可以直接用来筛选。手动改过标签的主体不受规则影响。
        </p>
      </div>
      <TagRulePanel />
    </div>
  )
}
